import { render, staticRenderFns } from "./DashboardKpiCard.vue?vue&type=template&id=44fc55e8&scoped=true"
import script from "./DashboardKpiCard.vue?vue&type=script&lang=js"
export * from "./DashboardKpiCard.vue?vue&type=script&lang=js"
import style0 from "./DashboardKpiCard.vue?vue&type=style&index=0&id=44fc55e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fc55e8",
  null
  
)

export default component.exports